import * as authAction from '@/store/modules/auth/action-types'
import * as clientAction from '@/store/modules/client/action-types'
import * as administrationAction from '@/store/modules/administration/action-types'
import * as uiAction from '@/store/modules/ui/action-types'

export default {  
  ...authAction,
  ...clientAction,
  ...administrationAction,
  ...uiAction
}